<main role="main">
  <router-outlet></router-outlet>
</main>
<app-toast-list></app-toast-list>
